/* eslint-disable prettier/prettier */
import { Dispatch } from 'redux';
import {
  PURCHASE_POLICY_START,
  PURCHASE_POLICY_SUCCESS,
  PURCHASE_POLICY_FAILED,
  SWITCH_ORG_FAILED,
  SWITCH_ORG_START,
  RESET_POLICY_CREATE,
  AdditionalData
} from './types';
import { ReduxStore } from '../payload-types';
import { ApiClient } from '../api.client';
import { AUTH_HEADERS, FEATURE_FLAGS, LINKS, LOGIN_ROUTES } from '@trip-ux/constants';
import { preparePolicy } from '../request.mappers';
import { checkFeatureFlag } from '../utils';
import { toUpper, get, isEmpty } from 'lodash';
import axios from 'axios';
import { GET_CLAIMS_SUCCESS, SET_USER } from '../user-profile';

export const createPolicy =
  (callback = () => null, isQuote: boolean = false, additionalData?: AdditionalData) =>
  async (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<unknown> => {
    let state = getState();
    const userProfile = state.userProfile;
    const userListing = state.userListing;
    const selectedAgent = get(state.travellersDetails, 'originalFormData.agent', '') as string;
    let agentList = [];
    if (!isEmpty(userListing.data)) {
      agentList = userListing.data.records.map(a => {
        const formattedAgentInfo = `${a.firstName} ${a.lastName} (${a.profileCode})`;
        return { label: formattedAgentInfo, value: a.profileRef };
      });
      agentList.push({ label: 'Manulife (LIA)', value: 'LIA' });
    }

    const agent = agentList.filter(ag => ag.label == selectedAgent)[0]?.value;

    if (userProfile.organizationCategory === 'AGENCY' && !isQuote) {
      dispatch({ type: SWITCH_ORG_START });
      try {
        if (userProfile.userType === AUTH_HEADERS.LAN_ID && userProfile.distributor !== agent) {
          let headers = {};
          if (agent === 'LIA') {
            headers = { newOrg: userProfile.organizationCode };
          } else {
            headers = { newDistrib: agent, newOrg: userProfile.organizationCode };
          }
          await axios.get(LOGIN_ROUTES.AUTH_SET_USER, { headers });
        } else if (userProfile.userType === AUTH_HEADERS.CIAM_ID) {
          //redo token before purchase to see if licensing still valid
          await axios.get(LOGIN_ROUTES.AUTH_SET_CIAM_USER, {
            headers: { newOrg: userProfile.organizationCode }
          });
        }
        const response = await axios.get(LOGIN_ROUTES.AUTH_GET_USER);
        const { user, claims } = response.data;
        dispatch({ type: SET_USER, payload: user });
        dispatch({ type: GET_CLAIMS_SUCCESS, payload: { claims: claims, user: user } });
      } catch (e) {
        dispatch({ type: SWITCH_ORG_FAILED, payload: e });
      }
      state = getState();
    }
    dispatch({ type: PURCHASE_POLICY_START });
    const requestPayload = preparePolicy(state, isQuote);

    const useDestinationPricing = checkFeatureFlag(state.userProfile?.featureFlags, FEATURE_FLAGS.DESTINATION_PRICING);

    return apiClient(dispatch, getState)
      .post(LINKS.POLICY, requestPayload, {
        headers: { lang: toUpper(state.config.locale), ...(useDestinationPricing && { 'api-version': '2' }) }
      })
      .then(payload => {
        dispatch({ type: PURCHASE_POLICY_SUCCESS, payload, additionalData, isQuoteSave: isQuote });
        callback();
      })
      .catch(e => {
        dispatch({ type: PURCHASE_POLICY_FAILED, payload: e });
      });
  };

export const clearPolicyCreate = () => (dispatch: Dispatch) => {
  dispatch({
    type: RESET_POLICY_CREATE
  });
};
